// src/data/projects.js
const projects = {
    orion: {
        title: "ORION I: Mach-26",
        description: "The UK's premier competition for advanced, high-powered rocketry, hosted at a future spaceport in Scotland. This mission is designed for experienced teams to tackle ambitious objectives like high-altitude flights, stage separation, and complex payloads, demonstrating cutting-edge capabilities.\n",

    },

    atlas: {
        title: "ATLAS I",
        description: "National Rocketry Championships (NRC)\n" +
            "The UK's largest university rocketry competition, providing hands-on experience in designing, building, and launching a mid-power rocket. It's the perfect entry-level project to develop foundational skills and compete on a national stage.",
    },

    hermes: {
        title: "HERMES I: BMFA Challenge 5 Weight",
        description: "An intense aeronautical engineering contest to design and build a model aircraft with the highest possible payload-to-weight ratio. This challenge, supported by leaders in the aerospace industry, pushes teams to innovate in structural efficiency and lightweight design, mirroring real-world aircraft development.",

    },

    icarus: {
        title: "ICARUS I: EuRoC 2026",
        description: "Compete against Europe's best at the continent's premier university rocketry event, organised by the Portuguese Space Agency. This prestigious challenge involves launching a high-power rocket to altitudes of several kilometres, showcasing advanced engineering and innovation on an international platform.\n",

    }
};

export default projects;